import type { ThemeName } from "@huub-web/ui";

/**
 * Locales available by default, from `VITE_AVAILABLE_LOCALES` (fallback "nl").
 */
const ENV_LOCALES = ((import.meta.env.VITE_AVAILABLE_LOCALES as string) || "nl")
  .split(",")
  .map((locale: string) => locale.trim())
  .filter(Boolean);

/**
 * Per-theme locale overrides. Themes not listed fall back to `ENV_LOCALES`.
 * Domek.nl is a multilingual brand, so it additionally offers Polish.
 */
const THEME_LOCALES: Partial<Record<ThemeName, string[]>> = {
  domek: [...new Set([...ENV_LOCALES, "nl", "en", "pl"])],
};

/**
 * Locales offered in the language switcher — and the only locales i18next is
 * allowed to activate — for the given theme. i18next's `supportedLngs` is
 * gated to this set, so a stale `huub_locale` cookie or `?language=` value for
 * a locale the active theme doesn't offer (e.g. Polish on Huub) cannot leave
 * the UI in a language missing from the switcher.
 */
export const getAvailableLocales = (theme: ThemeName): string[] =>
  THEME_LOCALES[theme] ?? ENV_LOCALES;

/**
 * Display labels for the language switcher, keyed by locale code.
 */
export const LOCALE_LABELS: Record<string, string> = {
  nl: "Nederlands",
  en: "English",
  pl: "Polski",
};
